<template>
  <path
    d="M14.91 6.71016C14.52 6.32016 13.89 6.32016 13.5 6.71016L8.90999 11.3002C8.51999 11.6902 8.51999 12.3202 8.90999 12.7102L13.5 17.3002C13.89 17.6902 14.52 17.6902 14.91 17.3002C15.3 16.9102 15.3 16.2802 14.91 15.8902L11.03 12.0002L14.91 8.12016C15.29 7.73016 15.29 7.09016 14.91 6.71016Z"
  />
</template>
